export default __webpack_public_path__ + "static/media/2026.d40ac452.png";